<ng-container *ngIf="showBreadcrumbs">
  <div class="breadcrumbs">
    <div class="d--none--sm" *ngIf="!loading">
      <ul class="breadcrumbs__list">
        <li [ngClass]="{ 'breadcrumbs__list-item--parent': !parent }">
          <a [airLink]="homePage ? homePage._url : '/'" [userEventSource]="userEventSource">
            {{ homePage && homePage.title ? homePage.title : ("general.label.home" | translate) }}
          </a>
        </li>
        <li *ngIf="showDots">...</li>
        <li *ngIf="parent" class="breadcrumbs__list-item--parent">
          <a [airLink]="parent.url" [userEventSource]="userEventSource">{{ parent.title }}</a>
        </li>
        <li>{{ currentPageTitle }}</li>
      </ul>
    </div>

    <!-- For mobile, show a link with back button functionality -->
    <div class="d--none d--block--sm">
      <ul class="breadcrumbs__list">
        <li class="breadcrumbs__list-item--parent" backButton>
          <a>{{ "general.label.back" | translate }}</a>
        </li>
      </ul>
    </div>
  </div>
</ng-container>
